import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'

const answers: AnswerType[] = [
  {
    emoji: '⏰',
    title: 'pages.onboarding.stopsQuestion.answer1',
  },
  {
    emoji: '😴',
    title: 'pages.onboarding.stopsQuestion.answer2',
  },
  {
    emoji: '📆',
    title: 'pages.onboarding.stopsQuestion.answer3',
  },
  {
    emoji: '😰',
    title: 'pages.onboarding.stopsQuestion.answer4',
  },
  {
    emoji: '😕',
    title: 'pages.onboarding.stopsQuestion.answer5',
  },
  {
    emoji: '🤔',
    title: 'pages.onboarding.stopsQuestion.answer6',
  },
]

export default function StopsQuestionPage() {
  return (
    <SingleChoiceQuestionPage
      answers={answers}
      subtitle="pages.onboarding.stopsQuestion.subtitle"
      title="pages.onboarding.stopsQuestion.title"
    />
  )
}
